var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('v-img',{attrs:{"src":require("../assets/banner.jpg"),"height":"550px"}})],1),_c('div',[_c('news',{attrs:{"datas":{ news: _vm.news, notice: _vm.notice},"show-pagination":true},on:{"page":_vm.handlePage}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }